export const blogSliderData = [
    {
        id: 1,
        title: "Complete SEO for Websites",
        desc: "Search Engine Optimization (SEO): The practice of optimizing your website to rank higher in search engine results pages (SERPs)...",
        img: "/assets/images/blog-card-images/complete-seo.png",
        facebook: "https://www.facebook.com/",
        linkedin: "https://www.linkedin.com/feed/",
        pageLink: "/blog/complete-seo-for-websites",
    },
    {
        id: 2,
        title: "What is Website Management?",
        desc: "Website Management: The ongoing process of maintaining, updating and securing a website to ensure it functions properly, stays current...",
        img: "/assets/images/blog-card-images/website-management.png",
        facebook: "https://www.facebook.com/",
        linkedin: "https://www.linkedin.com/feed/",
        pageLink: "/blog/what-is-website-management",
    },
    {
        id: 3,
        title: "User Interface (UI) Design",
        desc: "User Interface (UI) Design: The process of designing the visual elements with in a digital product (website, app, software).",
        img: "/assets/images/blog-card-images/user-interface-design.png",
        facebook: "https://www.facebook.com/",
        linkedin: "https://www.linkedin.com/feed/",
        pageLink: "/blog/user-interface-design",
    },
    {
        id: 4,
        title: "What is Brand Identity?",
        desc: "Brand Identity: The visual, verbal, and experiential elements that represent your brand and distinguish it from competitors.",
        img: "/assets/images/blog-card-images/brand-identity.png",
        facebook: "https://www.facebook.com/",
        linkedin: "https://www.linkedin.com/feed/",
        pageLink: "/blog/what-is-brand-identity",
    },
    {
        id: 5,
        title: "Core UX Design Principles",
        desc: "Design for your users, not yourself Understand user needs, goals, and pain points Base decisions on user research...",
        img: "/assets/images/blog-card-images/core-ux-design.png",
        facebook: "https://www.facebook.com/",
        linkedin: "https://www.linkedin.com/feed/",
        pageLink: "/blog/core-ux-design",
    },
]